import { COLOR_SCHEME_CLASS_NAME_REG_EXP } from "./constants.js";
function colorSchemeClassName(scheme) {
  if (typeof scheme === "string") {
    return `scheme-${scheme}`;
  } else {
    return void 0;
  }
}
function isColorSchemeClassName(value) {
  return COLOR_SCHEME_CLASS_NAME_REG_EXP.test(value);
}
export {
  colorSchemeClassName,
  isColorSchemeClassName
};
//# sourceMappingURL=colorSchemeClassName.js.map
